import { cn } from '@/lib/utils'
import { useMediaQuery } from '@/hooks/use-media-query'

interface CardProps {
  title: string
  description?: string
  className?: string
  children?: React.ReactNode
  headerButton?: React.ReactNode
}
export function Card({ title, description, className, children, headerButton }: CardProps) {
  const isSmAndDown = useMediaQuery('(max-width:768px)')

  return (
    <div className={cn('bg-card border border-border rounded-2xl px-4 py-4 min-w-auto shadow-soft', className)}>
      <div className={cn('flex w-full', isSmAndDown && 'flex-col')}>
        <div className="justify-between w-full">
          <h1 className="text-xl sm:text-2xl text-foreground font-semibold">{title}</h1>
          {description && <p className="text-sm sm:text-base text-muted-foreground mt-1">{description}</p>}
        </div>

        <div className={cn('flex items-center justify-end', isSmAndDown && 'min-w-full pb-3 pt-6')}>{headerButton}</div>
      </div>

      {children}
    </div>
  )
}
